import { useContext, useState, useEffect, Suspense } from "react";
import { Storage } from "aws-amplify";
import ProductContext from "../../contexts/ProductContext";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { MediaUri, ProductStatus, sortOrders } from "../../constants/enum";
import { FcDownload } from "react-icons/fc";
import { downloadResolutionOptions } from "../../constants/enum";
import { FaDownload } from "react-icons/fa";
import ModalConfirm from "../../components/ModalConfirm";
import { downloadBlob } from "../../helpers/download";
import Footer from "../../components/Footer";
import { API, graphqlOperation } from "aws-amplify";
import { searchProductLibProducts } from "../../graphql/queries";
import wrapPromise from "../../helpers/wrapPromise";
import { extractSearchProducts } from "../../helpers/extract";
import Card from "../../components/Card";
import Waiting from "../../components/Waiting";
import InfoCard from "./infoCard";
import Select from "react-select";

function SingleProduct() {
  const { product } = useContext(ProductContext);
  const productInfo: any = product;
  const mainImages = product ? product["files"] : [];
  const [galleryImages, setGalleryImages] = useState<any>([]);
  const [showDialog, setShowDialog] = useState(false);
  const [downloadResolution, setDownloadResolution] = useState(
    downloadResolutionOptions[0].value
  );

  useEffect(() => {
    const signImage = async () => {
      if (mainImages.length > 0) {
        const mediaEndpoints = mainImages.map((mi: any) => {
          return { ...mi };
        });

        const sortMedia = mediaEndpoints
          .map((d: any) => {
            const typeSub = d.mediaTypeSub ? d.mediaTypeSub : "OTHER";
            const imgIndex = sortOrders.indexOf(typeSub.toUpperCase());

            return {
              ...d,
              sortOrder:
                imgIndex || imgIndex === 0 ? imgIndex : sortOrders.length,
            };
          })
          .sort((a: any, b: any) => {
            const imgA = a.sortOrder ? a.sortOrder : 0;
            const imgB = b.sortOrder ? b.sortOrder : 0;
            return imgA - imgB;
          });

        await setGalleryImages(sortMedia);
      }
    };
    if (mainImages) {
      signImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mainImageObjects = galleryImages.map((img: any) => ({
    original: `${MediaUri}/display/${img.path}`,
    thumbnail: `${MediaUri}/thumbnail/${img.path}`,
    description: `${img.name}`,

    renderItem: () => {
      return (
        <div className="flex flex-row justify-center">
          <div className="px-8 py-4">
            <div className="relative" data-te-dropdown-ref>
              <button
                className="float-left p-2 bg-white rounded-full shadow-lg hover:bg-slate-400 shadow-slate-400"
                type="button"
                id="dropdownMenuButton1"
                data-te-dropdown-toggle-ref
                aria-expanded="false"
                data-te-ripple-init
                data-te-ripple-color="light"
              >
                <FcDownload size={25} />
              </button>
              <ul
                className="absolute z-[1000] float-left m-0 hidden min-w-max list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg dark:bg-neutral-700 [&[data-te-dropdown-show]]:block"
                aria-labelledby="dropdownMenuButton1"
                data-te-dropdown-menu-ref
              >
                {downloadResolutionOptions.map((op: any) => {
                  return (
                    <li key={op.value}>
                      <button
                        className="block w-full px-4 py-2 text-sm font-bold bg-transparent whitespace-nowrap text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-400 dark:text-neutral-200 dark:hover:bg-neutral-600"
                        data-te-dropdown-item-ref
                        onClick={async () => {
                          let source =
                            op.value === "HIGH"
                              ? "downloads/large"
                              : op.value === "MEDIUM"
                              ? "downloads/medium"
                              : op.value === "LOW"
                              ? "downloads/small"
                              : "original";

                          const result = await Storage.get(
                            `${source}/${img.path}`,
                            { download: true, 
                              // contentType: "image/png" 
                            }
                          );

                          // const result = await Storage.get(key, { download: true });
                          downloadBlob(
                            result.Body,
                            `${op.value}-${img.mediaType}-${img.mediaTypeSub}-${img.name ? img.name.replace(".", "") : "_.png"}`
                          );
                        }}
                      >
                        <span>{`${op.label}`}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>

            <img
              className="object-contain w-48 rounded-t-lg h-fit md:w-96 "
              src={`${MediaUri}/display/${img.path}`}
              alt={`${img.name}`}
              onError={(e: any) => {
                e.target.src = "/brands/no_image.png";
              }}
            />
          </div>
        </div>
      );
    },
  }));

  const fetchProductSeries = () => {
    const products: any = API.graphql(
      graphqlOperation(searchProductLibProducts, {
        sort: [{ direction: "desc", field: "name" }],
        filter: {
          and: [
            { brandType: { eq: `${productInfo.brandType}` } },
            {
              productHierachy: {
                eq: `${productInfo.productHierachy.substring(0, 13)}0`, // last digit of product hierachy = 0.
              },
            },
            { packaging: { eq: "EA" } },
            {
              or: [
                { status: { eq: ProductStatus.Launch } },
                { status: { eq: ProductStatus.Normal } },
                { status: { eq: ProductStatus.TobeDiscontinued } },
                // { status: { eq: ProductStatus.Relaunch } },
              ],
            },
          ],
        },
        limit: 25,
      })
    );

    return {
      products: wrapPromise(products),
    };
  };

  const pds = fetchProductSeries();

  const ShowProductSerires = ({ pds }: any) => {
    const products = pds.products.read();
    const productSeries = extractSearchProducts(products);
    if (!productSeries || productSeries.length === 0) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-xl font-bold text-gray-400">
            No ea information.
          </span>
        </div>
      );
    }

    return (
      <div className="px-8 py-4">
        <h2 className="text-xl">Product Serie(s)</h2>
        <div>
          <div className="grid justify-center grid-cols-1 gap-4 p-4 lg:grid-cols-4">
            {productSeries.map((sr: any) => {
              if (productInfo.id === sr.value.id) {
                return (
                  <div key={sr.value.id}>
                    <Card data={sr.value} />
                  </div>
                );
              }
              return (
                <div key={sr.value.id}>
                  <Card data={sr.value} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const fetchProductPack = () => {
    const product: any = API.graphql(
      graphqlOperation(searchProductLibProducts, {
        sort: [{ direction: "desc", field: "name" }],
        filter: {
          and: [
            { brandType: { eq: `${productInfo.brandType}` } },
            { materialCode: { eq: `${productInfo.materialCode}` } },
            {
              productHierachy: {
                eq: `${productInfo.productHierachy}`, // last digit of product hierachy = 0.
              },
            },
            { packaging: { eq: "PAC" } },
          ],
        },
        limit: 1,
      })
    );

    return {
      product: wrapPromise(product),
    };
  };
  const pdp = fetchProductPack();

  const ShowProductPack = ({ pdp }: any) => {
    const product = pdp.product.read();
    const productPack = extractSearchProducts(product);
    if (!productPack || productPack.length === 0) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-xl font-bold text-gray-400">
            No pack information.
          </span>
        </div>
      ); //go to un auth page.
    }

    const productInfoCard = productPack.map((info: any) => {
      const value = info.value;

      return {
        ...value,
        tags: JSON.parse(value.tags),
        functions: JSON.parse(value.functions),
      };
    });

    return <InfoCard info={productInfoCard[0]} />;
  };

  const fetchProductCase = () => {
    const product: any = API.graphql(
      graphqlOperation(searchProductLibProducts, {
        filter: {
          and: [
            { materialCode: { eq: `${productInfo.materialCode}` } },
            {
              productHierachy: {
                eq: `${productInfo.productHierachy}`, // last digit of product hierachy = 0.
              },
            },
            { packaging: { eq: "CS" } },
          ],
        },
        limit: 1,
      })
    );

    return {
      product: wrapPromise(product),
    };
  };
  const pdc = fetchProductCase();

  const ShowProductCase = ({ pdc }: any) => {
    const product = pdc.product.read();
    const productCase = extractSearchProducts(product);
    if (!productCase || productCase.length === 0) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-xl font-bold text-gray-400">
            No case information.
          </span>
        </div>
      ); //go to un auth page.
    }

    const productInfoCard = productCase.map((info: any) => {
      const value = info.value;

      return {
        ...value,
        tags: JSON.parse(value.tags),
        functions: JSON.parse(value.functions),
      };
    });

    return <InfoCard info={productInfoCard[0]} />;
  };

  return (
    <>
      <ModalConfirm
        show={showDialog}
        onHide={() => {}}
        title="Download file(s)"
        cancelText={"Close"}
        cancelAction={async () => {
          await setShowDialog(false);
        }}
        okClass="btn-submit"
        okText="Download"
        okAction={async () => {
          let source =
            downloadResolution === "HIGH"
              ? "downloads/large"
              : downloadResolution === "MEDIUM"
              ? "downloads/medium"
              : downloadResolution === "LOW"
              ? "downloads/small"
              : "original";

          await productInfo.files.map(async (fl: any) => {
            const key = `${source}/${fl.path}`;
            const result = await Storage.get(key, {
              download: true,
              // contentType: "image/png",
            });
            downloadBlob(
              result.Body,
              `${downloadResolution}-${fl.mediaType}-${fl.mediaTypeSub}-${fl.name ? fl.name.replace(".", "") : "_.png"}`
            );
          });
          await setShowDialog(false);
        }}
        maxWidth="max-w-4xl"
      >
        {showDialog ? (
          <div className="overflow-auto h-96">
            <div className="flex flex-row justify-center px-4 py-2">
              <div className="w-full">
                <Select
                  options={downloadResolutionOptions}
                  defaultValue={downloadResolutionOptions[0]}
                  onChange={(e: any) => {
                    setDownloadResolution(e.value);
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {productInfo.files.map((file: any) => {
                return (
                  <div key={file.id} className="flex flex-row m-2">
                    <img
                      className="object-contain h-24"
                      src={`${MediaUri}/thumbnail/${file.path}`}
                      alt={`${file.name}`}
                    />
                    <div className="grid justify-between grid-cols-1">
                      <span className="font-bold">{file.name}</span>
                      <div className="grid grid-cols-1 gap-0">
                        <span className="text-xs">{file.mediaType}</span>
                        <span className="text-xs">{file.mediaTypeSub}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-center">
            <span>No Data</span>
          </div>
        )}
      </ModalConfirm>
      <div className="grid grid-cols-1 p-1 m-1 lg:p-4 lg:m-4 md:grid-cols-2">
        {productInfo.files.length > 0 ? (
          <div className="flex flex-row justify-center">
            <div className="object-contain w-4/5 py-4 h-fit">
              <ImageGallery
                items={mainImageObjects}
                infinite={false}
                showBullets={true}
                showIndex={true}
                showFullscreenButton={true}
                showPlayButton={false}
                onErrorImageURL="/brands/no_image.png"
              />
              <div className="flex flex-row justify-center mt-8">
                <button
                  type="button"
                  onClick={() => {
                    setShowDialog(true);
                  }}
                  disabled={productInfo.files.length === 0}
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="disabled:bg-slate-500  inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                >
                  <span className="flex flex-row justify-center gap-2">
                    <FaDownload size={15} /> <span> Download all file(s)</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-center p-4 rounded ">
            <div className="grid w-full grid-rows-3 rounded bg-slate-100">
              <div className="row-span-1 row-start-2 font-bold uppercase text-slate-500">
                <div className="flex flex-row justify-center">
                  <span className="text-xl lg:text-4xl">No Image(s)</span>
                </div>
              </div>{" "}
            </div>
          </div>
        )}

        <div className="px-4 py-4 my-8 bg-gray-100 rounded shadow-lg lg:py-8 lg:px-10 md:my-2">
          <ul
            className="flex flex-row flex-wrap pl-0 mb-4 list-none border-b-0"
            id="tabs-tab3"
            role="tablist"
            data-te-nav-ref
          >
            <li role="presentation">
              <a
                href="#tabs-home3"
                className="my-2 block border-x-0 border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
                id="tabs-home-tab3"
                data-te-toggle="pill"
                data-te-target="#tabs-home3"
                data-te-nav-active
                role="tab"
                aria-controls="tabs-home3"
                aria-selected="true"
              >
                EA
              </a>
            </li>
            <li role="presentation">
              <a
                href="#tabs-profile3"
                className="focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
                id="tabs-profile-tab3"
                data-te-toggle="pill"
                data-te-target="#tabs-profile3"
                role="tab"
                aria-controls="tabs-profile3"
                aria-selected="false"
              >
                PACK
              </a>
            </li>
            <li role="presentation">
              <a
                href="#tabs-messages3"
                className="focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
                id="tabs-messages-tab3"
                data-te-toggle="pill"
                data-te-target="#tabs-messages3"
                role="tab"
                aria-controls="tabs-messages3"
                aria-selected="false"
              >
                CASE
              </a>
            </li>
          </ul>

          <div>
            <div
              className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
              id="tabs-home3"
              role="tabpanel"
              data-te-tab-active
              aria-labelledby="tabs-home-tab3"
            >
              <InfoCard info={productInfo} />
            </div>
            <div
              className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
              id="tabs-profile3"
              role="tabpanel"
              aria-labelledby="tabs-profile-tab3"
            >
              <Suspense fallback={<Waiting />}>
                <ShowProductPack pdp={pdp} />
              </Suspense>
            </div>
            <div
              className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
              id="tabs-messages3"
              role="tabpanel"
              aria-labelledby="tabs-profile-tab3"
            >
              <Suspense fallback={<Waiting />}>
                <ShowProductCase pdc={pdc} />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Waiting />}>
        <ShowProductSerires pds={pds} />
      </Suspense>

      <Footer />
    </>
  );
}

export default SingleProduct;
